<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0050_approval_history</div>
        <!-- <app-header>esma</app-header> -->
        <div :class="'container ' + pageContainerSize">
          <!-- <title-and-search title="申請承認"></title-and-search> -->
          <search-control
          style="padding-bottom: 10px;"
          :field_names="allSearchFields" @change="searchControlChangedDatasource"></search-control>
          <div>
            <input
              @click="allChecked($event.target.value,$event.target)"
              style="float: right;"
              v-model="checkBoxSelectAll"
              :disabled="approveMode == 'reject'"
              type="checkbox" id="checkBoxSelectAll" name="checkBoxSelectAll" value="X">
          </div>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button
            :disabled="disablePageApprove || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary"
            style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;margin-right: 12px;"
            @click="bulkApprovalStage1"
            >承認</button>
            <button :disabled="disablePageApprove || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;"
            @click="bulkApprovalStage4" >申請クリア</button>
　　　　　　<button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;" @click="initExportFile" >出力</button>
          </div>
          <button
            v-if="filteringRrejectMode == false"
            :disabled="disablePageApprove || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-danger"
            style="min-width:100px;float: right;margin-left: 10px;margin-right: 12px;"
            @click="bulkRejectStage1"
            >一括差戻</button>

          <button
          v-if="filteringRrejectMode == true"
          :disabled="rejectedBulkEditDisabled || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" @click="bulkEdit"
            >{{bulkEditText}}</button>
        </div>
        <file-download-modal tag="runDeviceEmbededInformationDownloadModal" @close="onCloseExportFile"/>
        <confirmation-modal tag="stage1ConfirmatioModal" @done="bulkApprovalStage2" />
        <confirmation-modal tag="stage2ConfirmatioModal" @done="bulkApprovalStage3" />
        <confirmation-modal tag="bulkApprovalStage4ConfirmatioModal" @done="bulkClearApprovalStage4Confirmation" />
        <bulk-reject-modal tag="bulkRejectModal" @closed="bulkRejectStage2"/>
        <confirmation-modal tag="stage2RejectConfirmatioModal" @done="bulkRejctStage3" />
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_approval_history';
import { utils } from '@/libs/utils';
import _ from 'lodash';
import uuid from "uuid";

import _debug from 'debug';
var mdebug = _debug('esma:approval_history');
import fieldBoxes from '@/components/form-field';
import moment from "moment";
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import constants from "@/rules/constants";

import fileDownloadModal from '@/components/modals/file-download-modal';
import bulkRejectModal from '@/components/modals/bulk-reject-modal';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal,
    'bulk-reject-modal':bulkRejectModal
  },
  data() {
    return {
      api_name:"approval_history",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      execute_filter_on_back:true,
      page_acl: acl.approval_history,
      user_id:"",
      is_logged_user_admin:false,
      load_only_with_filter:false,
      disable_page_approve:true,
      select_all:false,
      link_to_open:"#",
      filtering_reject_mode:false,
      rejected_bulk_edit_selected_records_qty:0,
      rejected_bulk_edit_disabled:false,
      rejected_bulk_edit_sybetu:"",
      selected_approval_history_name:"selected_approval_history",
      state_last_filter_options:"last_filter_options_history"
    };
  },
  computed: {
    selectedApprovalHistoryName:{
      get(){
        if(this.filteringRrejectMode == true){
          return this.selected_approval_history_name + "_rejected";
        }else{
          return this.selected_approval_history_name;
        }
      },
      set(v){
        this.selected_approval_history_name = v;
      }
    },
    bulkEditText(){
      if(this.rejectedBulkEditSelectedRecordsQty == 0){
        return "一括編集";
      }else{
        return "一括編集" + " ("+this.rejectedBulkEditSelectedRecordsQty+")";
      }
    },
    rejectedBulkEditSelectedRecordsQty:{
      get(){
        return this.rejected_bulk_edit_selected_records_qty;
      },
      set(v){
        this.rejected_bulk_edit_selected_records_qty = v;
      }
    },
    rejectedBulkEditDisabled:{
      get(){
        return this.rejected_bulk_edit_disabled;
      },
      set(v){
        this.rejected_bulk_edit_disabled = v;
      }
    },
    filteringRrejectMode:{
      get(){
        return this.filtering_reject_mode;
      },
      set(v){
        this.filtering_reject_mode = v;
      }
    },
    approveMode:{
      get(){
        return this.approve_mode;
      },
      set(v){
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll:{
      get(){
        return this.select_all;
      },
      set(v){
        this.select_all = v;
      }
    },
    disablePageApprove:{
      get(){
        return this.disable_page_approve;
      },
      set(v){
        this.$emit("bRLFlag",!v);
        this.disable_page_approve = v;
      }
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    isLoggedUserAdmin:{
      get(){
        return this.is_logged_user_admin;
      },
      set(v){
        this.is_logged_user_admin = v;
      }
    },
    userId:{
      get(){
        return this.user_id;
      },
      set(v){
        this.user_id = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    allSearchFields(){
      return [
          fields.approval_status,
          fields.current_status,
          fields.syubetu,
          fields.control_number,
          fields.toroku_number,
          fields.bulk_toroku_number,
          fields.applicant_label,
          fields.department,
          fields.next_approver_label,
          fields.update_name_label,
          fields.create_time,
          fields.update_time
      ]
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {
          search_no_blank:true,
          options: [
            "承認済", // Approved
            "申請中",   // Applying
            "差戻"      //Reject
          ]
        }),
        utils.extend(fields.current_status, {}),
        utils.extend(fields.syubetu, {}),
        utils.extend(fields.control_number, {}),
        utils.extend(fields.toroku_number, {}),
        utils.extend(fields.bulk_toroku_number, {}),

        utils.extend(fields.applicant_label, {}),
        utils.extend(fields.department, {}),
        utils.extend(fields.next_approver_label, {}),
        utils.extend(fields.update_name_label, {}),

        utils.extend(fields.create_time, {}),
        utils.extend(fields.update_time, {}),
      ];
    }
  },
  methods: {
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDeviceEmbededInformationDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search:this.search_data,
        url:"/approval_history/export_data/"
      });
    },
    onCloseExportFile(){},
    allChecked(a,b){
      // It should be selected at server side.
      setTimeout(() => {
        if(this.checkBoxSelectAll == true){
          var ops = {check:this.checkBoxSelectAll}
          if(this.last_data_source_filter){
            ops.filter = this.last_data_source_filter
          }
          var url = "/approval_history/select_all_checkable";
          if(this.filteringRrejectMode == true){
            url = "/approval_history/select_all_rejected_checkable";
          }
          this.$ajax.post(url,ops, (err, result) => {
            Vue.localStorage.set(this.selectedApprovalHistoryName,JSON.stringify(result || []))
            this.refreshSelectedRecord();
          })
        }else{
          this.bulkClearApprovalStage4Confirmation("yes")
        }
      }, 100);
    },
    bulkRejectStage1(){
      var qty = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName).length;
      bus.$emit("bulkRejectModal",{
        qty:qty
      })
    },
    bulkEdit(){
      var sybetu = this.rejected_bulk_edit_sybetu[0];
      var p_id = uuid.v4()
      var url = false;
      if(sybetu ==  constants.SYUBETU.DEVICE){
        url = "/device_embedded_information/bulk_edit/" + p_id;
      }else if(sybetu == constants.SYUBETU.CERTIFICATE){
        url = "/certificate/bulk_edit/" + p_id;
      }
      if(url){
        var arr = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName)
        this.$ajax.post("/approval_history/get_rejected_details_for_edit",{arr}, (err, result) => {
          var obj = {arr:result.map(m=>{return m.fk_id})}
          Vue.localStorage.set("bulk_edit_" + p_id, JSON.stringify(obj));
          return this.$router.push(url);
        })
      }
    },
    bulkRejectStage2(obj){
      if(obj && obj.mode == "yes"){
        var arr = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName)
        var hash = 0;
        arr.forEach(e =>{
          hash = hash + ((e + 3) * 2) // Simple hash to avoid direct request
        })
        this.$ajax.post("/approval_history/bulk_reject", {arr,hash,changes:{retraction_reason:obj.value}}, (err, response) => {
          console.log({response})
          this.$store.state["current_field_style"] = {};
          this.$store.state["current_field_style2"] = {};
          if(err){
            var title = "データの差戻に失敗しました。";
            if(err && err.indexOf("::") == 0){
              title = err.replace("::","");
              err = ""
            }
          this.$notify({
              title: title,
              text:err,
              type: "error",
              duration: 10000
            });
          }else{
            this.bulkClearApprovalStage4Confirmation("yes")
            this.gridOptions.api.purgeInfiniteCache();
            bus.$emit("stage2RejectConfirmatioModal",{
              title: "差戻が完了しました。",
              message: "",
              yes_label: "",
              no_label: "戻る",
              yes_color:"info",
              no_color:"default",
              model_height:"50"
            })
          }
        });
      }
    },
    bulkRejctStage3(){
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkRejctStage3");
    },
    bulkApprovalStage1(){
          var qty = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName).length;
          bus.$emit("stage1ConfirmatioModal",{
            title: "選択中　"+qty+"件",
            message: "承認を行います。よろしいですか？",
            yes_label: "承認",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
    },
    bulkApprovalStage2(mode){
      /**
       * 2 - When aprove, execute at the server
       * 3 - Then show the results message.
       */
      if(mode != "yes"){
        return;
      }
      var arr = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName)
      var hash = 0;
      arr.forEach(e =>{
        hash = hash + ((e + 3) * 2) // Simple hash to avoid direct request
      })
      this.$ajax.post("/approval_history/approve", {arr,hash}, (err, response) => {
        console.log({response})
        this.$store.state["current_field_style"] = {};
        this.$store.state["current_field_style2"] = {};
        if(err){
          var title = "データの承認に失敗しました。";
          if(err && err.indexOf("::") == 0){
            title = err.replace("::","");
            err = ""
          }
        this.$notify({
            title: title,
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          this.bulkClearApprovalStage4Confirmation("yes")
          this.gridOptions.api.purgeInfiniteCache();
          bus.$emit("stage2ConfirmatioModal",{
            title: "承認が完了しました。",
            message: "",
            yes_label: "",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });

    },
    bulkApprovalStage3(){
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkApprovalStage3");
    },
    bulkClearApprovalStage4Confirmation(mode){
      if(mode == "yes"){
        Vue.localStorage.set(this.selectedApprovalHistoryName,JSON.stringify([]))
        this.refreshSelectedRecord();
      }
    },
    bulkApprovalStage4(mode){
      bus.$emit("bulkApprovalStage4ConfirmatioModal",{
        title: "",
        message: "申請の確認状態をクリアします。<br>よろしいですか？",
        yes_label: "OK",
        no_label: "戻る",
        yes_color:"info",
        no_color:"default",
        model_height:"50"
      })

    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      var destination = "";
      if(data.fk_tab == constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION){
        destination =  "/device_embedded_information/approval/" + data.seq_id + "/" + data.fk_id;
      }else if(data.fk_tab == constants.TABLE_ID.CERTIFICATE_INFORMATION){
        destination =  "/certificate_information/approval/" + data.seq_id + "/" + data.fk_id;
      }else if(data.fk_tab == constants.TABLE_ID.CERTIFICATE_SOFTWARE){
        destination =  "/certificate/approval/" + data.seq_id + "/" + data.fk_id;
      }else{
          this.$notify({
            title: "FK ID or FK TAB was not found.",
            text: "There are some problem with the fk data.",
            type: "error",
            duration: 10000
          });
          return;
      }
      console.log('onDetailsClick', {destination});

      return this.$router.push(destination);
    },
    refreshSelectedRecord(selected_approval_history=false){
      this.rejectedBulkEditSelectedRecordsQty = 0;
      this.rejectedBulkEditDisabled = true;
      this.rejected_bulk_edit_sybetu = [];
      if(selected_approval_history == false){
        selected_approval_history = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
      }
      var count_selected_on_memory = 0;
      this.gridOptions.api.forEachNode((node) => {
        if(node.data ){
          if(selected_approval_history.indexOf(node.data.seq_id) > -1){
            node.data.is_selected = true;
          }else{
            node.data.is_selected = false;
          }
          if(node.data.seq_id > 0 && node.data.is_selected == true){
            if(node.data.approval_status == "差戻"){
              this.rejectedBulkEditSelectedRecordsQty++;
              if(this.rejected_bulk_edit_sybetu.indexOf(node.data.syubetu) < 0){
                this.rejected_bulk_edit_sybetu.push(node.data.syubetu)
              }
              this.rejectedBulkEditDisabled = this.rejected_bulk_edit_sybetu.length != 1;
            }
            if(((this.isLoggedUserAdmin == true && node.data  && node.data.status_final == "未承認") || (node.data  && node.data.next_approver == this.userId)) && (node.data && (node.data.is_selected == true || this.isAllSelected == true))){
              count_selected_on_memory++;
            }
          }
        }
      })
      this.disablePageApprove = count_selected_on_memory == 0;
      this.gridOptions.api.refreshView();
    },

    onCheckBoxClick(ev,row){
      var selected_approval_history = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
      if(isNaN(row.seq_id) == false){
        var seq_id = row.seq_id;
        if(selected_approval_history.indexOf(seq_id) > -1){
          _.remove(selected_approval_history,(d)=> {return d == seq_id;})
        }else{
          selected_approval_history.push(seq_id)
        }
        Vue.localStorage.set(this.selectedApprovalHistoryName,JSON.stringify(selected_approval_history))
      }
      this.refreshSelectedRecord()
    },
    createColumnDefs() {
      var arr = [
        {
          headerName: 'Seq',
          field: 'seq_id',
          hide: true,
          // sort: 'desc'
        },
         {
            headerName: "SearchControl",// Used to filter manually
            field: "search_control",
            hide: true
        },
        {
          headerName: "SearchFlowControl", // Used to filter manually
          field: "search_flow_control",
          hide: true,
        },
      ];
      var i = 0;
      this.tabFieldList.forEach((f) => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };

        if(f.type == "date_picker" ){
          fi.cellRenderer = (params) =>{
              return utils.format_date(params.value);
          }
        }else if(f.type == "select" ){
          fi.cellRenderer = (params) =>{
            if(f.table_field_style && _.size(f.table_field_style ) > 0){
              return "<span style='"+f.table_field_style[params.value]+"'>" +params.value +"</span>" ;
            }else{
              return params.value;
            }
          }
        }else if(f.type == "datetime_picker" || f.type == "current_time"){
          fi.cellRenderer = (params) =>{
              return utils.format_date_time(params.value);
          }
        }else if(f.cellRenderer){
          fi.cellRenderer = f.cellRenderer;
        }

        arr.push(fi);
      });


      [fields.more_details, fields.record_checked].forEach(f => {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          // sort : f.id == "record_checked" ? 'desc':null,
          cellRenderer: params => {
            if (params.column.colId == "more_details") {
              if((this.isLoggedUserAdmin == true && params.data  && params.data.status_final == "未承認") || (params.data  && (params.data.next_approver == this.userId || params.data.applicant == this.userId ))){
                return this.createGridTextButton(
                "詳細",
                "color: #5b9bd5;",
                this.onDetailsClick,
                params.data
              );
              }else{
                return "-"
              }
            }
            if (params.column.colId == "record_checked") {
              if(this.hideCheckBox(params.data) == true){
                  return ""
              }
              return this.createGridButton(
                (params.data && params.data.record_checked == 1)?"glyphicon glyphicon glyphicon-check":"glyphicon glyphicon glyphicon-unchecked",
                "color: #5b9bd5;",
                (ev,selected_row)=>{
                  this.onCheckBoxClick(ev,selected_row)
                },
                params.data
              );
            }
          }
        };
        arr.push(fi);
      });


      return arr;
    },
    hideCheckBox(data){
      if(data){
        var found_to_hide = false;
        [1,2,3,4,5].forEach((f) => {
          if(data["approver_" + f] == this.userId && data["status_" + f] != "未承認" ){
            found_to_hide = true;
          }
        })
        if(found_to_hide == true){
          return true;
        }
      }
      if(data && (data.applicant == this.userId && data.approval_status == "差戻" )){
        return false
      }else if(data && (data.next_approver == this.userId  || (data.next_approver == "ライセンス管理窓口（最終承認）" && this.isApproverAdminForSimpleApprove  && data.applicant != this.userId ))){
        return false
      }else{
        return true;
      }
    },
  },
  mounted() {
    if(this.$route.meta.mode =="rejected"){
      window.sessionStorage.setItem('device_back_to_list', "/approval_history/rejected")
      window.sessionStorage.setItem('certificate_back_to_list', "/approval_history/rejected")
    }else{
      window.sessionStorage.setItem('device_back_to_list', "/approval_history")
      window.sessionStorage.setItem('certificate_back_to_list', "/approval_history")
    }
    // bus.$emit("onSearchClear",{})
    this.gridOptions.api.sizeColumnsToFit();
    setTimeout(()=>{
      if(this.$route.meta.mode =="toroku_filter"){
        bus.$emit("onOpenPageFilter",{field:"bulk_toroku_number",val:this.$route.params.bulk_toroku_number})
      }else if(this.$store.state["last_filter_options_history"]){
        var lfo = this.$store.state[this.stateLastFilterOptions][this.api_name];
        if(this.executing_filter_on_back == true || (lfo && lfo.filter && lfo.filter["1"] && lfo.filter["1"].value )){
          // Do nothing
        }else if(this.$route.meta.mode =="rejected"){
          bus.$emit("onOpenPageFilter",{field:"approval_status",val:'差戻'})
        }else{
          setTimeout(()=>{
            lfo = this.$store.state["last_filter_options_history"]["approval_history"];
            if(this.executing_filter_on_back == true || (lfo && lfo.filter && lfo.filter["1"] && lfo.filter["1"].value )){
              // Do nothing
            }else if(this.$route.meta.mode =="rejected"){
              bus.$emit("onOpenPageFilter",{field:"approval_status",val:'差戻'})
            }else{
              bus.$emit("onOpenPageFilter",{field:"approval_status",val:'申請中'})
            }
          },100)
        }
      }
    },100)
    this.userId = Vue.localStorage.get("userID") || "";
    this.isLoggedUserAdmin = this.isAdmin ;
    this.$ajax.post("/approval_history/count_prepared", {}, (err, qty) => {
      this.$emit("selectedItemsUpd",qty||0);
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    var use_data_source = true;

    //AG Grid options
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: (data) => {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onColumnResized: (ev, b) => {
      },
      onRowSelected: ev => {
      },
      onModelUpdated: (ev, d) => {
      },
      onGridReady:() => {

      },
      getRowStyle: params => {
        if((this.isLoggedUserAdmin == true && params.node.data  && params.node.data.status_final == "未承認") || (params.node.data  && params.node.data.next_approver == this.userId) || (params.node.data  && params.node.data.applicant == this.userId && params.node.data.approval_status == "差戻" )){
          if (params.node.data && (params.node.data.is_selected == true || this.isAllSelected == true)) {
            if(this.hideCheckBox(params.data) == true){
              return {}
            }else{
              return { background: "orange" };
            }
          }
        }
      },
    };
    this.initDatasource({load_only_with_filter:false,loaded_cb:(err,data)=>{
      this.filteringRrejectMode = false;
      if(this.stateLastFilterOptions && this.api_name &&  this.$store.state[this.stateLastFilterOptions] && this.$store.state[this.stateLastFilterOptions][this.api_name]){
        if(this.$store.state[this.stateLastFilterOptions][this.api_name].filter && this.$store.state[this.stateLastFilterOptions][this.api_name].filter["1"]){
          this.filteringRrejectMode =  this.$store.state[this.stateLastFilterOptions][this.api_name].filter["1"].value == "差戻" &&  this.$store.state[this.stateLastFilterOptions][this.api_name].filter["1"].field == "approval_status";
        }
      }
      var active_approve_button = _.find(data,(d)=>{
        if(this.hideCheckBox(d) == true){
          return false;
        }
        return ((this.isLoggedUserAdmin == true && d  && d.status_final == "未承認") || (d  && d.next_approver == this.userId)) && (d && (d.is_selected == true ||d.record_checked ==1 || this.isAllSelected == true))
      })
      this.disablePageApprove = typeof active_approve_button == "undefined";
      this.refreshSelectedRecord();
    }});
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// approval_history.vue?58d58262